// Only the email is remembered: never the password, tokens or OTP. Logout keeps
// this key on purpose so the next sign-in is prefilled.
export const REMEMBERED_EMAIL_KEY = "cocoPortal.rememberedEmail";

export const getRememberedEmail = () => {
  try {
    return localStorage.getItem(REMEMBERED_EMAIL_KEY) || "";
  } catch (error) {
    return "";
  }
};

export const saveRememberedEmail = (email, remember) => {
  try {
    const value = String(email || "").trim();
    if (remember && value) {
      localStorage.setItem(REMEMBERED_EMAIL_KEY, value);
    } else {
      localStorage.removeItem(REMEMBERED_EMAIL_KEY);
    }
  } catch (error) {
    // Signing in must not depend on browser storage availability.
  }
};
